export default {
    to: "/dashboard/publications",
    order: 3,
    icon: "mdi-script",
    title: "Publications",
    disabled: false,
    value: 0,
    sublinks: [],
}
